export const HEADER_INIT                = 'HEADER_INIT'
export const ACCESS_DENIED_ACTION       = 'ACCESS_DENIED_ACTION'
export const HEADER_REQUESTING          = 'HEADER_REQUESTING'
export const HEADER_REQUEST_SUCCESS     = 'HEADER_REQUEST_SUCCESS'
export const HEADER_REQUEST_ERROR       = 'HEADER_REQUEST_ERROR'  

export const HEADER_SET_ACTIVE_BRANCH_REQUESTING  = 'HEADER_SET_ACTIVE_BRANCH_REQUESTING'
export const HEADER_SET_ACTIVE_BRANCH_SUCCESS     = 'HEADER_SET_ACTIVE_BRANCH_SUCCESS'
export const HEADER_SET_ACTIVE_BRANCH_ERROR       = 'HEADER_SET_ACTIVE_BRANCH_ERROR'  

export const HEADER_REQUEST_API         = '/api/v1/users/getinfor'
export const HEADER_SET_ACTIVE_BRANCH_API         = '/api/v1/users/set_active_branch'


// WEBPACK FOOTER //
// ./src/components/Header/constants.js